import create from './createAction'

export const SET_FORM_INFO = 'SET_FORM_INFO'
export const setFormInfo = create(SET_FORM_INFO)
